import { Element, Component, Host, h } from '@stencil/core';
import { slotHasAnyContent, showSlotParentContent } from '../../utils/slotHelpers';

export interface AhaModalFooter extends HTMLAhaModalFooterElement {}

/**
 *
 * @slot secondary_actions - Contents of the left side of the footer
 * @slot DEFAULT - Contents of the right side of the footer.
 */
@Component({
  tag: 'aha-modal-footer',
  styleUrl: 'aha-modal-footer.css',
  shadow: true,
})
export class AhaModalFooter {
  @Element() hostElement!: HTMLAhaModalFooterElement;

  connectedCallback() {
    if (!this.hostElement.slot && this.hostElement.parentElement?.tagName === 'AHA-MODAL') {
      this.hostElement.slot = 'modal-footer';
    }
  }

  componentDidRender() {
    const slot = this.hostElement.shadowRoot?.querySelector(
      'slot[name="footer_text"]',
    ) as HTMLSlotElement;
    if (slot && slot.parentElement) {
      slotHasAnyContent(slot)
        ? slot.parentElement.removeAttribute('hidden')
        : slot.parentElement.setAttribute('hidden', '');
    }
  }

  render() {
    return (
      <Host>
        <slot name="content">
          <div class="footer">
            <slot name="secondary_actions"></slot>
            <div class="footer__text">
              <slot name="footer_text" onSlotchange={showSlotParentContent}></slot>
            </div>
            <div class="footer__actions">
              <slot></slot>
            </div>
          </div>
        </slot>
      </Host>
    );
  }
}
